import { connect } from "react-redux";
import ResetPasswordAfterLogin from "../components/ResetPassword/ResetPasswordAfterLogin";
import * as selector from "../redux/selectors/accountSettingSelector";
import * as actions from "../redux/actions/ResetPassword";
import { getUser } from "../redux/actions/AccountSetting";
import { getQueryVariable } from "../utils/utils";
import { push } from "react-router-redux";

const mapStateToProps = (state) => {
  return {
    user: selector.getUser(state),
    error: state.resetPassword.error,
    isResetting: state.resetPassword.resetting,
    message: state.resetPassword.message,
    shortMessage: state.resetPassword.shortMessage,
    errorMessage: state.resetPassword.errorMessage,
    firstTime:
      getQueryVariable(state.router.location.search, "first_time", "true") ===
      "true",
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUserInfo() {
    dispatch(getUser());
  },

  postUsersUpdatePassword(data) {
    dispatch(actions.postUsersUpdatePassword(data));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordAfterLogin);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordAfterLogin.js